import React, { useState, useEffect, useContext, useMemo } from 'react';
import { useAccount } from 'wagmi';

import { CurrencyContext } from 'context';
import useGameDetails from 'utils/Hooks/useGameDetails.js';
import HistoryRound from './round.js';


function HistoryPage(props) {
  const gameDetails = useGameDetails();

  const { currencyID } = useContext(CurrencyContext);
  const account = useAccount();

  const [wantedBets, SetWantedBets] = useState(null);


  useEffect(() => {
    FetchWantedBets();
    const refresher = setInterval(FetchWantedBets, 10000);
    return () => {
      clearInterval(refresher);
    }
  }, [props.totalHistoryLength, props.start, props.length, props.number,
    wantedBets, gameDetails, account?.address]); // eslint-disable-line react-hooks/exhaustive-deps


  async function FetchWantedBets() {
    if (!account?.address || !gameDetails.contracts.prediction || !props.totalHistoryLength)
      return;
    const newWantedBets = await gameDetails.contracts.prediction.methods.GetUserRounds(
      account?.address, props.start, props.length).call();
    const newLastRoundID = newWantedBets['0'][props.length - 1];
    if (!wantedBets) {
      SetWantedBets(newWantedBets);
    } else {
      const oldLastRoundID = wantedBets['0'][props.length - 1];
      if (oldLastRoundID !== newLastRoundID)
        SetWantedBets(newWantedBets);
    }
  }


  const lastBetsFormattedM = useMemo(GetLastBetsFormatted, [account?.address, wantedBets]);
  function GetLastBetsFormatted() {
    if (!account?.address || !wantedBets)
      return [];
    const roundNumbers = wantedBets['0']; // .values
    const lastBetsInfo = wantedBets['1']; // .betInfo
    let lastBetsFormatted = [];
    for (let i = 0; i < lastBetsInfo.length; i++) {
      const betFormatted = {
        roundID: roundNumbers[i],
        claimed: lastBetsInfo[i].claimed,
        position: lastBetsInfo[i].position,
        amount: lastBetsInfo[i].amount,
      };
      lastBetsFormatted.push(betFormatted);
    }
    return lastBetsFormatted.reverse();
  }

  const mCurrentRounds = useMemo(CurrentRounds, [lastBetsFormattedM, wantedBets, currencyID]);
  function CurrentRounds() {
    let lastRounds = [];
    if (lastBetsFormattedM.length == -1 || !wantedBets) // eslint-disabled-eqeqeq
      lastRounds = (<tr>
        <td colSpan='9' className='HistoryEnd'>
          Loading...
        </td>
      </tr>);
    else
      for (const round of lastBetsFormattedM) {
        lastRounds.push(<HistoryRound
          key={round.roundID}
          roundID={round.roundID}
          positionEntered={round.position}
          betAmount={round.amount}
          claimed={round.claimed}
          fiatID={currencyID}
        />);
      }
    return lastRounds;
  }


  return mCurrentRounds;
};

export default HistoryPage;